import React from "react";

import img6 from "../../assets/myprofile.png";
import img7 from "../../assets/mastergp1.png";
import img8 from "../../assets/topfood.png";
import img9 from "../../assets/autocare.png";
import img10 from "../../assets/ccns.png";
import img11 from "../../assets/mines.png";
import "./Portfolio.css";
import Modal from "../common/ModalWindows.js";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import i18n from "../../languages/i18n";
import MasterGpGallery from "./MasterGpGallery";
// => React Element
//    <a className="github" href="https://github.com"><b>GitHub</b></a>
import { useState } from "react";
const topfoodDesc = `Top foods app is a simple app witch provide users with a set of features including :<br>
1. foods ranking based on nutrient amount.<br>
2. search USDA database for foods.<br>
3. get detailed nutrients information's from USDA database.<br>
4. compare foods by nutrients.<br>
5. multi-language support (English and Arabic implemented, additional language will be available on next updates).<br>

`;
const topfoodDesc_ar = `
هي تطبيقة  أندرويد توفر للمستخدمين مجموعة من الميزات منها:<br>
ترتيب الأطعمة على أساس كمية العناصر.<br>
البحث في قاعدة بيانات وزارة الزراعة الأمريكية عن الأطعمة.<br>
الحصول على معلومات مفصلة عن العناصر الغذائية من قاعدة بيانات وزارة الزراعة الأمريكية.<br>
مقارنة الأطعمة اعتمادا على عناصرها .<br>
دعم عدة لغات ( اللغة الإنجليزية والعربية ، وستتوفر لغات إضافية في التحديثات القادمة).<br>
واجهة رسومية ترتكز على البساطة والكفاءة.<br>
`;
const masterGPdesc = `
An ERP developed for a mid-size company (<em>4MK L'AUTOCOLLANT, Tunisia</em>).<br>
It Includes core features :
<ul><li>➡ Orders.</li> <li>➡ Sales.</li> <li>➡ Billing.</li> <li>➡ Inventory</li> <li>➡ Production</li> <li>...</li></ul>

`;
const masterGpDesc_ar = `
واحدة من أفضل أعمالي التي قمت بتطويرها لفائدة شركة صناعية متوسطة الحجم  بتونس 4MK L'Autocollant  <br>
و هي منظومة لإدارة موارد الشركة باستخدام البيئة التطويرية  Windev ( واجهة المستخدم باللغة الفرنسية).<br>
و قد شملت MAster GP  على أهم الوظائف نذكر منها :<br>
إدارة العلاقات مع العملاء <br>
إدارة المبيعات.<br>
إدارة خط الإنتاج.<br>
إدارة المخازن <br>
....
`;
const portfolio_desc = "My personal web site ";
const ccns_desc =
  "Company web site prototype.<br>Company name: CCNS<br>Country:Tunisia ";
const ccns_desc_ar = "نموذج موقع واب لشركة تونسية <br> الشركة :CCNS";
const portfolio_desc_ar = "موقع الواب الخاص بي وهو هذا الموقع الذي تتصفحه";
const autoCare_desc = `A Car maintenance tracker witch provide user with a set a feature :<br>
- Service reminders.<br>
- Fill-Up tracker.<br>
- Expense tracker, and more ...<br>
`;
const autoCare_desc_ar = `سوف يتم نشرها قريبا.تطبيق أندروويد لمتابعة صيانة المركبات و التي توفر للمستخدم مجموعة خدمات منها :<br>
خدمة التذكير بمواعيد الصيانة <br>
.خدمة متابعة صرفية البنزين <br>
خدمة متابعة النفقات و الكثير من الخدمات الأخرى
`;
const mines_desc = `Minesweeper: Old Times!
Experience the nostalgic thrill of the classic Windows XP Minesweeper, now reimagined for mobile.<br>This first release includes:<br>
Classic XP-style grid and gameplay<br>
Three difficulty levels: Beginner, Intermediate, Expert<br>
Touch-friendly controls with tap and long-press<br>
Clean, ad-free experience<br>
`;
const mines_desc_ar = `لعشاق هذه اللعبة من الزمن الجميل، الآن متاحة على جوالك`;
const Portfolio = () => {
  const [showDesc, setShowDesc] = useState(false);
  const [selectedItem, setSelectedItem] = useState(0);
  const [showGallery, setShowGallery] = useState(false);

  const { t } = useTranslation();
  const projects = [
    {
      id: 0,
      image: img7,
      title: "Windows App: MAster GP ERP",
      demo: "https://www.youtube.com/watch?v=1Ybk0Z_wyTc",
      aosAnimation: "fade-right",
      description: i18n.language === "en" ? masterGPdesc : masterGpDesc_ar,
      btnTitle: t("portfolioScreen.demo_btn_title"),
      framework: "PC SOft Windev",
    },
    {
      id: 1,
      image: img8,
      title: "Android App: Top foods",
      demo: "https://play.google.com/store/apps/details?id=com.top_foods",
      aosAnimation: "fade-up",
      description: i18n.language === "en" ? topfoodDesc : topfoodDesc_ar,
      btnTitle: t("portfolioScreen.getApp_btn_title"),
      framework: "React-native",
    },
    {
      id: 2,
      image: img9,
      title: "Android App : Auto Care",
      demo: "https://play.google.com/store/apps/details?id=com.smichi.autocare.basic",
      aosAnimation: "fade-right",
      description: i18n.language === "en" ? autoCare_desc : autoCare_desc_ar,
      btnTitle: t("portfolioScreen.getApp_btn_title"),
      framework: "React-native",
    },
    {
      id: 3,
      image: img10,
      title: "Company web site ",
      demo: "https://www.ccn-services.com/",
      aosAnimation: "fade-left",
      description: i18n.language === "en" ? ccns_desc : ccns_desc_ar,
      btnTitle: t("portfolioScreen.visit_btn_title"),
      framework: "ReactJS",
    },

    {
      id: 4,
      image: img6,
      title: "Web App : My portfolio website",
      demo: "#",
      aosAnimation: "fade-left",
      description: i18n.language === "en" ? portfolio_desc : portfolio_desc_ar,
      btnTitle: t("portfolioScreen.visit_btn_title"),
      framework: "ReactJS",
    },
    {
      id: 5,
      image: img11,
      title: "Minesweeper mobile game",
      demo: "https://play.google.com/store/apps/details?id=com.smichi.minesweeper",
      aosAnimation: "fade-left",
      description: i18n.language === "en" ? mines_desc : mines_desc_ar,
      btnTitle: t("portfolioScreen.visit_btn_title"),
      framework: "React-Native",
    },
  ];

  return (
    <section id="portfolio">
      <h5 className={i18n.language === "ar" && "arabicText"}>
        {t("portfolioScreen.myWork_title")}
      </h5>
      <h2 className={i18n.language === "ar" && "arabicText"}>
        {t("portfolioScreen.portfolio_title")}
      </h2>
      <div className="container portfolio_container">
        {/** Project 1 */}
        {projects.map((item) => {
          return (
            <div
              className="portfolio_item "
              data-aos="fade-right"
              data-aos-duration="1500"
              key={item.id}
            >
              <div className="portfolio_item-image">
                <img src={item.image} alt="" />
              </div>
              <h3>{item.title}</h3>

              <div className="portfolio_item-cta">
                <a
                  href="#portfolio"
                  className={
                    i18n.language === "en"
                      ? "btn-submit"
                      : "btn-submit arabicText"
                  }
                  onClick={() => {
                    setSelectedItem(item.id);
                    setShowDesc(true);
                  }}
                >
                  {t("portfolioScreen.desc_btn_title")}
                </a>
                {item.id === 0 ? (
                  <a
                    href="#portfolio"
                    className={
                      i18n.language === "en"
                        ? "btn btn-primary"
                        : "btn btn-primary arabicText"
                    }
                    onClick={() => setShowGallery(true)}
                  >
                    {item.btnTitle}
                  </a>
                ) : (
                  <a
                    href={item.demo}
                    className={
                      i18n.language === "en"
                        ? "btn btn-primary"
                        : "btn btn-primary arabicText"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.btnTitle}
                  </a>
                )}
              </div>
            </div>
          );
        })}
        {/** Modal description */}
        <Modal
          show={showDesc}
          handleClose={() => setShowDesc(false)}
          onscrollHandler={() => setShowDesc(false)}
          closeTitle={t("btn_close_title")}
        >
          <div className={i18n.language === "ar" && "arabicText rtlText"}>
            {parse(projects[selectedItem].description)}
          </div>
          <h3>
            <strong>Framework: {projects[selectedItem].framework}</strong>
          </h3>
        </Modal>
        <MasterGpGallery
          show={showGallery}
          handleClose={() => setShowGallery(false)}
          onscrollHandler={() => setShowGallery(false)}
        />
      </div>
    </section>
  );
};

export default Portfolio;
